// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HospitalOpinion_container__QM6UM{
    background: #fff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.10);
    box-sizing: border-box;
}

.HospitalOpinion_container__QM6UM .HospitalOpinion_top__wez70{display: flex;align-items: center; margin-bottom: 20px;}

.HospitalOpinion_container__QM6UM .HospitalOpinion_top__wez70 .HospitalOpinion_tit__2rjfY{
    font-size: 18px;
    font-weight: 700;
}

/* 병원 소견서 저장소 */
.HospitalOpinion_hos_opi__KqhGI {
    display: flex;
    flex-direction: column;
    height:100%;
}
.HospitalOpinion_hos_opi__KqhGI .HospitalOpinion_top__wez70 {
    padding:20px 10px;
    border-bottom: 1px solid #EBEBEB;
    margin:0 !important;
}
.HospitalOpinion_hos_opi__KqhGI .HospitalOpinion_box__rCeqO {
    display: flex;
    height: 100%;
    overflow-y:hidden;
}

/* left menu */
.HospitalOpinion_hos_opi__KqhGI .HospitalOpinion_box__rCeqO .HospitalOpinion_left__h\\+s3J {
    display: flex;
    flex-direction: column;
    border-right: 1px solid #EBEBEB;
    overflow-y: auto;
}

.HospitalOpinion_left__h\\+s3J .HospitalOpinion_menu__rBKw2 {
    margin: 5px 20px;
    padding: 10px 12px;
    border-radius: 12px;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
}

.HospitalOpinion_left__h\\+s3J .HospitalOpinion_menu__rBKw2:hover {
    color:#51D7DF;
    background-color: rgba(81, 215, 223, 0.09);
}

.HospitalOpinion_left__h\\+s3J .HospitalOpinion_menu__rBKw2.HospitalOpinion_select__IMI4Z {
    color:#51D7DF;
    background-color: rgba(81, 215, 223, 0.09);
}


/* right menu */
.HospitalOpinion_hos_opi__KqhGI .HospitalOpinion_box__rCeqO .HospitalOpinion_right__vKIXA {
    flex:5 1;
    overflow-y: auto;
    min-height:650px;
    display:flex;
    flex-direction:column;
}

.HospitalOpinion_right__vKIXA .HospitalOpinion_header__vNAEp {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    border-bottom: 1px solid #EBEBEB;
}

.HospitalOpinion_right__vKIXA .HospitalOpinion_menu__rBKw2 {
    display: flex;
    justify-content: space-between;
    font-size:16px;
    font-weight: 700;
    gap:30px;
    padding: 5px 10px;
    cursor: pointer;
}

.HospitalOpinion_right__vKIXA .HospitalOpinion_contents__oTkQN {
    flex:1 1;
}

.HospitalOpinion_contents__oTkQN .HospitalOpinion_details__S23ub {
    display: flex;
    min-height:500px;
    max-height:520px;
    flex-direction: column;
    padding: 20px;
    overflow-y:scroll;
}

.HospitalOpinion_details__S23ub .HospitalOpinion_info__YE-NT {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    border-bottom : 1px solid #EBEBEB;
}

.HospitalOpinion_details__S23ub .HospitalOpinion_info__YE-NT > div {
   display:flex;
   flex-direction : row; 
   align-items: center;
   gap: 20px;
}

.HospitalOpinion_info__YE-NT .HospitalOpinion_title__xFyz9 {
    font-size: 18px;
    font-weight: 700;
}

.HospitalOpinion_info__YE-NT .HospitalOpinion_date__qFScP {
    font-size: 14px;
    color: #383838;
}

#HospitalOpinion_name__6YQ2p .HospitalOpinion_tit__2rjfY {
    font-size: 14px;
    color: #C4C4C4;
    font-style: bold;
}

#HospitalOpinion_name__6YQ2p p {
    font-size:14px;
    color: #383838;
}


.HospitalOpinion_details__S23ub .HospitalOpinion_section__unSV3 {
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    margin: 15px 0;
}

.HospitalOpinion_section__unSV3 .HospitalOpinion_column__OMqVH{
    display:flex;
    width:100%;
}

.HospitalOpinion_column__OMqVH > div {
    padding: 10px 20px;
}

.HospitalOpinion_column__OMqVH .HospitalOpinion_tit__2rjfY {
    background-color: rgba(90, 90, 90, 0.09);
    min-width: 117px;
    border: 1px solid #E8E8E8;
}

.HospitalOpinion_column__OMqVH .HospitalOpinion_obj__We4fY {
    width: 100%;
    border: 1px solid #E8E8E8;
    font-size: 14px;
}

.HospitalOpinion_column__OMqVH .HospitalOpinion_boldText__aVStO {
    font-weight: bold;
}

.HospitalOpinion_pagination__y6G2a {
    width:100%;
    display:flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap:15px;
}

.HospitalOpinion_pagination__y6G2a > button {
    font-size:14px;
    padding: 5px 10px;
}

/* 소견서 리스트 */
.HospitalOpinion_contents__oTkQN .HospitalOpinion_list__GE\\+jm {
    display: flex;
    padding:5px 20px;
    flex-direction: column;
}

.HospitalOpinion_list__GE\\+jm .HospitalOpinion_item__9z3LL {
    display:flex;
    width:100%;
    flex-direction: row;
    gap: 10px;
    font-size:12px;
    color:#000;
    font-weight: bold;
}
.HospitalOpinion_list__GE\\+jm .HospitalOpinion_item__9z3LL > div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding:5px 3px;
}

.HospitalOpinion_list__GE\\+jm .HospitalOpinion_item__9z3LL.HospitalOpinion_first__J9-n2 { 
    color: #B3B3B3 !important;
    font-weight: initial !important;
    border-bottom : 1px solid #EBEBEB;
    margin-bottom:10px;
}

.HospitalOpinion_item__9z3LL .HospitalOpinion_check__rA7\\+E { flex: 1 1; min-width: 30px;}

.HospitalOpinion_item__9z3LL .HospitalOpinion_title__xFyz9 {flex: 6 1;}

.HospitalOpinion_item__9z3LL .HospitalOpinion_recipient__muv8D,
.HospitalOpinion_item__9z3LL .HospitalOpinion_sender__hclL7,
.HospitalOpinion_item__9z3LL .HospitalOpinion_guardian_name__l6E0c,
.HospitalOpinion_item__9z3LL .HospitalOpinion_patient_name__8O9rv {
    flex: 2 1;
}
.HospitalOpinion_item__9z3LL .HospitalOpinion_sent_time__JFEa4 { flex: 3 1; text-align: right; }


`, "",{"version":3,"sources":["webpack://./src/pages/Setting/HospitalOpinion.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEX,gDAAgD;IAEhD,sBAAsB;AAClC;;AAEA,8DAA0D,aAAa,CAAkD,mBAAmB,EAAE,mBAAmB,CAAC;;AAElK;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;AACrB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,sBAAsB;IACtB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,0CAA0C;AAC9C;;;AAGA,eAAe;AACf;IACI,QAAM;IACN,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,gBAAgB;IAChB,QAAQ;IACR,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,QAAM;AACV;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,iCAAiC;AACrC;;AAEA;GACG,YAAY;GACZ,oBAAoB;GACpB,mBAAmB;GACnB,SAAS;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;;AAGA;IACI,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA,8DAAe,SAAO,EAAE,eAAe,CAAC;;AAExC,4DAAc,SAAO,CAAC;;AAEtB;;;;IAII,SAAO;AACX;AACA,iEAAmB,SAAO,EAAE,iBAAiB,EAAE","sourcesContent":[".container{\n    background: #fff;\n    padding: 20px;\n    border-radius: 10px;\n    -webkit-box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.10);\n            box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.10);\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n\n.container .top{display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-align: center;-ms-flex-align: center;align-items: center; margin-bottom: 20px;}\n\n.container .top .tit{\n    font-size: 18px;\n    font-weight: 700;\n}\n\n/* 병원 소견서 저장소 */\n.hos_opi {\n    display: flex;\n    flex-direction: column;\n    height:100%;\n}\n.hos_opi .top {\n    padding:20px 10px;\n    border-bottom: 1px solid #EBEBEB;\n    margin:0 !important;\n}\n.hos_opi .box {\n    display: flex;\n    height: 100%;\n    overflow-y:hidden;\n}\n\n/* left menu */\n.hos_opi .box .left {\n    display: flex;\n    flex-direction: column;\n    border-right: 1px solid #EBEBEB;\n    overflow-y: auto;\n}\n\n.left .menu {\n    margin: 5px 20px;\n    padding: 10px 12px;\n    border-radius: 12px;\n    font-size: 18px;\n    font-weight: 700;\n    cursor: pointer;\n}\n\n.left .menu:hover {\n    color:#51D7DF;\n    background-color: rgba(81, 215, 223, 0.09);\n}\n\n.left .menu.select {\n    color:#51D7DF;\n    background-color: rgba(81, 215, 223, 0.09);\n}\n\n\n/* right menu */\n.hos_opi .box .right {\n    flex:5;\n    overflow-y: auto;\n    min-height:650px;\n    display:flex;\n    flex-direction:column;\n}\n\n.right .header {\n    display: flex;\n    justify-content: space-between;\n    padding: 15px;\n    border-bottom: 1px solid #EBEBEB;\n}\n\n.right .menu {\n    display: flex;\n    justify-content: space-between;\n    font-size:16px;\n    font-weight: 700;\n    gap:30px;\n    padding: 5px 10px;\n    cursor: pointer;\n}\n\n.right .contents {\n    flex:1;\n}\n\n.contents .details {\n    display: flex;\n    min-height:500px;\n    max-height:520px;\n    flex-direction: column;\n    padding: 20px;\n    overflow-y:scroll;\n}\n\n.details .info {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px;\n    border-bottom : 1px solid #EBEBEB;\n}\n\n.details .info > div {\n   display:flex;\n   flex-direction : row; \n   align-items: center;\n   gap: 20px;\n}\n\n.info .title {\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.info .date {\n    font-size: 14px;\n    color: #383838;\n}\n\n#name .tit {\n    font-size: 14px;\n    color: #C4C4C4;\n    font-style: bold;\n}\n\n#name p {\n    font-size:14px;\n    color: #383838;\n}\n\n\n.details .section {\n    display:flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    align-items: center;\n    margin: 15px 0;\n}\n\n.section .column{\n    display:flex;\n    width:100%;\n}\n\n.column > div {\n    padding: 10px 20px;\n}\n\n.column .tit {\n    background-color: rgba(90, 90, 90, 0.09);\n    min-width: 117px;\n    border: 1px solid #E8E8E8;\n}\n\n.column .obj {\n    width: 100%;\n    border: 1px solid #E8E8E8;\n    font-size: 14px;\n}\n\n.column .boldText {\n    font-weight: bold;\n}\n\n.pagination {\n    width:100%;\n    display:flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap:15px;\n}\n\n.pagination > button {\n    font-size:14px;\n    padding: 5px 10px;\n}\n\n/* 소견서 리스트 */\n.contents .list {\n    display: flex;\n    padding:5px 20px;\n    flex-direction: column;\n}\n\n.list .item {\n    display:flex;\n    width:100%;\n    flex-direction: row;\n    gap: 10px;\n    font-size:12px;\n    color:#000;\n    font-weight: bold;\n}\n.list .item > div {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding:5px 3px;\n}\n\n.list .item.first { \n    color: #B3B3B3 !important;\n    font-weight: initial !important;\n    border-bottom : 1px solid #EBEBEB;\n    margin-bottom:10px;\n}\n\n.item .check { flex: 1; min-width: 30px;}\n\n.item .title {flex: 6;}\n\n.item .recipient,\n.item .sender,\n.item .guardian_name,\n.item .patient_name {\n    flex: 2;\n}\n.item .sent_time { flex: 3; text-align: right; }\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HospitalOpinion_container__QM6UM`,
	"top": `HospitalOpinion_top__wez70`,
	"tit": `HospitalOpinion_tit__2rjfY`,
	"hos_opi": `HospitalOpinion_hos_opi__KqhGI`,
	"box": `HospitalOpinion_box__rCeqO`,
	"left": `HospitalOpinion_left__h+s3J`,
	"menu": `HospitalOpinion_menu__rBKw2`,
	"select": `HospitalOpinion_select__IMI4Z`,
	"right": `HospitalOpinion_right__vKIXA`,
	"header": `HospitalOpinion_header__vNAEp`,
	"contents": `HospitalOpinion_contents__oTkQN`,
	"details": `HospitalOpinion_details__S23ub`,
	"info": `HospitalOpinion_info__YE-NT`,
	"title": `HospitalOpinion_title__xFyz9`,
	"date": `HospitalOpinion_date__qFScP`,
	"name": `HospitalOpinion_name__6YQ2p`,
	"section": `HospitalOpinion_section__unSV3`,
	"column": `HospitalOpinion_column__OMqVH`,
	"obj": `HospitalOpinion_obj__We4fY`,
	"boldText": `HospitalOpinion_boldText__aVStO`,
	"pagination": `HospitalOpinion_pagination__y6G2a`,
	"list": `HospitalOpinion_list__GE+jm`,
	"item": `HospitalOpinion_item__9z3LL`,
	"first": `HospitalOpinion_first__J9-n2`,
	"check": `HospitalOpinion_check__rA7+E`,
	"recipient": `HospitalOpinion_recipient__muv8D`,
	"sender": `HospitalOpinion_sender__hclL7`,
	"guardian_name": `HospitalOpinion_guardian_name__l6E0c`,
	"patient_name": `HospitalOpinion_patient_name__8O9rv`,
	"sent_time": `HospitalOpinion_sent_time__JFEa4`
};
export default ___CSS_LOADER_EXPORT___;
